import cn from 'classnames';
import React from 'react';

import ContentList from '@/components/ContentList/ContentList';
import appConfig from '@/config/appConfig.typed';
import {AUTO_DELIVERY_INACTIVE_BENEFITS_LIST_TITLE} from '@/consts/localization/localizationKeys';
import {getLocalizedStrings} from '@/services/localization/localizationService';

const AutoDeliveryStatusInactiveBenefits = ({className}) => {
    const localizedStrings = getLocalizedStrings();
    const list = appConfig.getAutoDeliveryDashboardInactiveBenefitsIcons();
    const title = localizedStrings[AUTO_DELIVERY_INACTIVE_BENEFITS_LIST_TITLE];

    return (
        <article className={cn('flex flex-col gap-4 empty:hidden', className)}>
            {title && <h3 className='text-20 leading-14'>{title}</h3>}
            <ContentList list={list} className='rounded-xl bg-primary-dark-5 p-4' />
        </article>
    );
};

export default AutoDeliveryStatusInactiveBenefits;
